const zhCN = {
  listVisitorName: '姓名',
  listVisitorPhone: '电话',
  listLicensePlate: '车牌号',
  listInterviewee: '被访问人',
  listIntervieweeOrg: '被访问人组织',
  listAuthorizedTime: '授权有效期',
  listSignInTime: '签到时间',
  listSignOutTime: '签离时间',
  listReserved: '是否预约',
  listYes: '是',
  listNo: '否',
  listOperation: '操作',

  listDetailBtn: '详情',

  visitorSettingsBtn: '访客设置',

  authorizedStartTimeTxt: '授权时间',
  authorizedEndTimeTxt: '授权时间',
  aWeekBeforeBtn: '前一周',
  oneMonthBeforeBtn: '前一个月',
  threeMonthsBeforeBtn: '前三个月',

  visitorOrgTxt: '所属机构',

  visitorOrInviterName: '访客或邀请人姓名',

  searchBtn: '搜索',

  exportBtn: '导出',

  getVisitorInfoFail: '获取访客记录失败！',

  getVisitorDetailFail: '获取预约访客详情失败！',

  modalVisitedRecordDetail: '到访记录详情',

  mVisitorTitle: '访客信息',
  mReservedPhoto: '预约现场照',
  mSignInPhoto: '到访签到照',
  mName: '访客姓名',
  mPhone: '手机号码',
  mCardType: '证件类型',
  mLicense: '车牌号',
  mIDNumber: '证件号码',
  mIsReserved: '是否预约',
  mYes: '是',
  mNo: '否',
  mSignInAt: '签到时间',
  mSignInDevice: '签到设备',
  mSignOutAt: '签离时间',
  mSignOutDevice: '签离设备',

  mBeVisitedInfoTitle: '被访问相关信息',
  mIName: '被访问人',
  mIOrg: '被访问人组织',
  mVisitRange: '访问时间',
  mVisitReason: '访问事由',
  mRemark: '备注',
  exportFilePrefix: '到访记录',
  exportSuccess: '导出成功！'
}
const enUS = {
  listVisitorName: 'Name',
  listVisitorPhone: 'Phone',
  listLicensePlate: 'License Plate',
  listInterviewee: 'Interviewee',
  listIntervieweeOrg: 'Interviewee Org',
  listAuthorizedTime: 'Authorized Time',
  listSignInTime: 'Sign In',
  listSignOutTime: 'Sign Out',
  listReserved: 'Reserved',
  listYes: 'Yes',
  listNo: 'No',
  listOperation: 'Operation',

  listDetailBtn: 'Detail',

  visitorSettingsBtn: 'Visitor Settings',

  authorizedStartTimeTxt: 'Authorized Time',
  authorizedEndTimeTxt: 'Authorized Time',
  aWeekBeforeBtn: 'a week before',
  oneMonthBeforeBtn: 'one month before',
  threeMonthsBeforeBtn: 'three months before',

  visitorOrgTxt: 'Visitor Organization',

  visitorOrInviterName: 'Visitor / Inviter Name',

  searchBtn: 'Search',

  exportBtn: 'Export',

  getVisitorInfoFail: 'Get the visitor record failed!',

  getVisitorDetailFail: 'Get visitor details failed!',

  modalVisitedRecordDetail: 'Visited Record Detail',

  mVisitorTitle: 'Visitor Info',
  mReservedPhoto: 'Reservation Photo',
  mSignInPhoto: 'Sign In Photo',
  mName: 'Name',
  mPhone: 'Phone',
  mCardType: 'ID Type',
  mLicense: 'License Plate',
  mIDNumber: 'ID Number',
  mIsReserved: 'is Reserved',
  mYes: 'Yes',
  mNo: 'No',
  mSignInAt: 'Sign In Time',
  mSignInDevice: 'Sign In Device',
  mSignOutAt: 'Sign Out Time',
  mSignOutDevice: 'Sign Out Device',

  mBeVisitedInfoTitle: 'Be Visited Info',
  mIName: 'Interviewer',
  mIOrg: 'Interviewer Org',
  mVisitRange: 'Visiting Period',
  mVisitReason: 'Visiting Reason',
  mRemark: 'Remark',
  exportSuccess: 'Export successful!'
}

export default { zhCN, enUS }
